import { render, staticRenderFns } from "./login.vue?vue&type=template&id=06c65bc8&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=06c65bc8&lang=scss&scoped=true&"
import style1 from "./login.vue?vue&type=style&index=1&lang=css&"
import style2 from "./login.vue?vue&type=style&index=2&id=06c65bc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c65bc8",
  null
  
)

export default component.exports